

<h3>Preview Report</h3>

<br>
<i>This list is constrained by your filters.  Click anywhere outside this dialog to close.</i>
<br>
<br>

<ag-grid-angular
    style="width: 95%; height: 600px;"
    class="ag-theme-balham"
    
    [rowData]="currentReportPreviewDataList"
    [columnDefs]="selectedCurrentReportColumns"
    (gridReady)="gridReady($event)">
</ag-grid-angular>